
function EsTituloDinamico(Question, Preguntas){

    let Original = Question;
    var dinamico = false;

    for (let Pregunta of Preguntas)
    {

        let Codigo = Pregunta["code"];
        let Buscar = '${'+Codigo+'}';

        let Reemplazar = Pregunta.response;

        var Question = Question.replace(Buscar, Reemplazar);

        if (Question != Original)
        {

            var dinamico = true;

        }


    }

    if (dinamico == true)
    {

        let retorno = { status: dinamico, data: Question };
        return retorno;

    } else {

        let retorno = { status: dinamico, data: Original };
        return retorno;

    }


}


exports.EsTituloDinamico = EsTituloDinamico;